var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.$style.link,attrs:{"href":_vm.href,"data-qa":"back_to_work"}},[(_vm.useIcon)?[_vm._v("←")]:_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }